import React from 'react';
import type { CSSProperties, ReactNode } from 'react';
import useStyles from '../../theme/useStyles';
import { iconify } from './Icon';

// Dashboard panel: a white card whose header carries the accent as an icon
// tint and a thin rule — the accent names the panel, it does not paint it.
// accent: purple | mint | peach
const ACCENTS = {
  purple: { light: '#8E44AD', dark: '#C39BD3' },
  mint:   { light: '#00897B', dark: '#4DB6AC' },
  peach:  { light: '#E65100', dark: '#FFAB91' }
};

export type WidgetAccent = 'purple' | 'mint' | 'peach';

export interface WidgetProps {
  title?: ReactNode;
  accent?: WidgetAccent;
  children?: ReactNode;
  style?: CSSProperties;
  isDarkMode?: boolean;
}

const Widget = ({ title, accent = 'purple', children, style, isDarkMode }: WidgetProps) => {
  const s = useStyles(isDarkMode);
  const t = s.t;
  const a = ACCENTS[accent] || ACCENTS.purple;
  const colour = t.isDarkMode ? a.dark : a.light;

  return (
    <div style={{
      ...s.widgetBox,
      backgroundColor: t.bgMain,
      border: `1px solid ${t.border}`,
      boxShadow: t.shadowCard,
      display: 'flex',
      flexDirection: 'column',
      ...style
    }}>
      <div style={{
        ...s.widgetHeader,
        display: 'flex', alignItems: 'center', gap: '10px',
        borderBottom: `1px solid ${t.border}`,
        borderTop: `3px solid ${colour}`
      }}>
        <h3 style={{ ...s.widgetTitle, color: t.textMain, display: 'flex', alignItems: 'center', gap: '8px' }}>
          {iconify(title, 18)}
        </h3>
      </div>
      <div style={{ padding: t.spacing.lg, flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
        {children}
      </div>
    </div>
  );
};

export default Widget;
